import { useState } from 'react'

interface YouTubeEmbedProps {
    videoId: string
    title?: string
}

export function YouTubeEmbed({ videoId, title }: YouTubeEmbedProps) {
    const [playing, setPlaying] = useState(false)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty title should fall back to the default label, not render blank
    const videoTitle = title || 'YouTube video'

    return (
        <div
            className="relative rounded-lg overflow-hidden border border-border-light dark:border-border-dark bg-black"
            style={{ paddingTop: '56.25%' }}
        >
            {playing ? (
                <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                    title={videoTitle}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
                />
            ) : (
                <button
                    type="button"
                    className="absolute inset-0 w-full h-full group"
                    aria-label={`Play ${videoTitle}`}
                    onClick={() => setPlaying(true)}
                >
                    <img
                        className="w-full h-full object-cover"
                        src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                        alt={videoTitle}
                        loading="lazy"
                    />
                    {/* Play button overlay */}
                    <span className="absolute inset-0 flex items-center justify-center">
                        <span className="flex items-center justify-center w-16 h-16 rounded-full bg-black/70 group-hover:bg-red-600 transition-colors duration-150">
                            <svg
                                className="w-7 h-7 text-white translate-x-0.5"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path d="M8 5v14l11-7z" />
                            </svg>
                        </span>
                    </span>
                </button>
            )}
        </div>
    )
}
